import { ref, computed } from 'vue'

export type CircuitState = 'closed' | 'open' | 'half-open'

const FAILURE_THRESHOLD = 3        // falhas consecutivas para abrir o circuito
const BASE_OPEN_MS      = 60_000   // tempo mínimo aberto antes de testar de novo
const MAX_OPEN_MS       = 600_000  // teto de 10min entre tentativas de teste

const _state    = ref<CircuitState>('closed')
const _failures = ref(0)
const _openMs   = ref(BASE_OPEN_MS)
let   _openedAt = 0

export const circuitState = computed(() => _state.value)

/**
 * Verifica se uma requisição pode ser feita agora.
 * - closed: sempre permite.
 * - open: bloqueia até o cooldown expirar, então libera UMA tentativa (half-open).
 * - half-open: permite a tentativa de teste já em andamento.
 */
export function canAttempt(): boolean {
  if (_state.value === 'closed') return true
  if (_state.value === 'half-open') return true
  if (Date.now() - _openedAt >= _openMs.value) {
    _state.value = 'half-open'
    return true
  }
  return false
}

export function recordSuccess(): void {
  _failures.value = 0
  _openMs.value    = BASE_OPEN_MS
  _state.value     = 'closed'
}

export function recordFailure(): void {
  _failures.value++
  if (_state.value === 'half-open') {
    // Teste de recuperação falhou — reabre e dobra o cooldown
    _openMs.value = Math.min(_openMs.value * 2, MAX_OPEN_MS)
    _state.value  = 'open'
    _openedAt     = Date.now()
    return
  }
  if (_failures.value >= FAILURE_THRESHOLD) {
    _state.value = 'open'
    _openedAt    = Date.now()
  }
}

export function secondsUntilRetry(): number {
  if (_state.value !== 'open') return 0
  return Math.max(0, Math.ceil((_openedAt + _openMs.value - Date.now()) / 1000))
}
